
import { cn } from "@/lib/utils";
import AnimatedCard from "../AnimatedCard";

interface InsightCardProps {
  title: string;
  description: string;
  icon?: React.ReactNode; // Make icon optional
  color: string;
  isActive?: boolean;
  onClick?: () => void;
  delay?: number;
  url?: string;
  image?: string;
}

export const InsightCard = ({
  title,
  description,
  icon,
  color,
  isActive = false,
  onClick,
  delay = 0,
  url,
  image
}: InsightCardProps) => {
  return (
    <AnimatedCard delay={delay} animation="scale-in" className="">
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer"
        className={cn(
          "insight-card transition-all duration-300 block overflow-hidden rounded-2xl",
          isActive ? "shadow-lg shadow-primary/10" : "hover:shadow-lg hover:shadow-primary/5",
          onClick ? "cursor-pointer" : ""
        )}
        style={{ height: '520px', display: 'flex', flexDirection: 'column' }}
        onClick={onClick}
      >
        {image ? (
          <div className="relative h-48 flex-shrink-0 overflow-hidden">
            <img 
              src={image} 
              alt={title}
              className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          </div>
        ) : null}
        
        <div className={cn(
          "p-6 backdrop-blur-lg bg-white/5 border border-white/10 flex flex-col justify-between",
          image ? "border-t-0" : "rounded-2xl"
        )}
        style={{ flex: '1' }}>
          <div className="flex items-start">
            {/* Only render icon if provided */}
            {icon && (
              <div className={cn("p-3 rounded-xl inline-flex items-center justify-center mb-4 flex-shrink-0", color)}>
                {icon}
              </div>
            )}
            <div className={cn("flex-1 flex flex-col", icon ? "ml-4" : "")}>
              <h3 className="text-xl font-semibold mb-3 leading-tight">{title}</h3>
              <p className="text-white/70 leading-relaxed">{description}</p>
            </div>
          </div>
        </div>
      </a>
    </AnimatedCard>
  );
};

export default InsightCard;
